import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/clients/$companyId/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/clients/$companyId/overview', params })
  },
})
